var map = {
	"./disgust.png": "df02",
	"./disgust1.png": "e70a",
	"./disgust2.png": "88b7",
	"./disgust3.png": "63d5",
	"./disgust4.png": "f516",
	"./fear1.png": "81b4",
	"./fear2.png": "838c",
	"./fear3.png": "0c9a",
	"./fear4.png": "4396",
	"./interest1.png": "1f26",
	"./interest2.png": "cb18",
	"./interest3.png": "f4d0",
	"./interest4.png": "0e88",
	"./joy.png": "ee7b",
	"./joy1.png": "b40e7",
	"./joy2.png": "54ad",
	"./joy3.png": "5db6",
	"./joy4.png": "2632",
	"./neutral.png": "dee6",
	"./sadness1.png": "019d",
	"./sadness2.png": "a829",
	"./sadness3.png": "c85a",
	"./sadness4.png": "3afc",
	"./surprise1.png": "5855",
	"./surprise2.png": "ee7a",
	"./surprise3.png": "4342",
	"./surprise4.png": "69b4",
	"./trust1.png": "e63a",
	"./trust2.png": "e34d",
	"./trust3.png": "4606",
	"./trust4.png": "5915"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f599";